import { useRouter } from 'next/router'
import { useSession } from 'next-auth/react'
import React, { useCallback } from 'react'

import { CentraizedLoader } from '@components/Loader'

export function Auth({ children, unauthorized }) {
  const router = useRouter()

  const handleUnauthenticated = useCallback(() => {
    router.push(unauthorized || '/')
  }, [router, unauthorized])

  const { status } = useSession({
    required: true,
    onUnauthenticated: handleUnauthenticated,
  })

  if (status === 'loading') {
    return <CentraizedLoader />
  }

  return children
}
